/** Full article bodies for blog posts */
export const BLOG_ARTICLES = {
  'ats-resume-guide': {
    sections: [
      {
        title: 'How ATS Parses Your Resume',
        paragraphs: [
          'Applicant tracking systems extract text from PDF and Word files, map it to database fields, and score relevance to the job description. Parsing fails when layouts use tables, text boxes, or unusual fonts. Use standard headings: Experience, Education, Skills.',
          'Keywords should appear naturally in context — job title variants, tools, and certifications mentioned in the posting. Avoid white text on white background tricks; modern systems detect manipulation.',
        ],
      },
      {
        title: 'Formatting Checklist',
        paragraphs: [
          'Single column, left-aligned, bullet characters like • or -. Save a plain-text copy to see what parsers read. Test by copying your PDF text into Notepad — if order is scrambled, fix structure before applying.',
        ],
      },
    ],
  },
  'resume-mistakes-to-avoid': {
    sections: [
      {
        title: 'Top Mistakes',
        paragraphs: [
          'Missing metrics, outdated objective statements, irrelevant job history, and unlabeled skills sections all reduce pass rates. Tailor each application; generic resumes rarely rank highest.',
        ],
      },
    ],
  },
  'static-vs-dynamic-qr-codes': {
    sections: [
      {
        title: 'When to Choose Static',
        paragraphs: [
          'Static QR codes embed the destination directly. They work offline for WiFi payloads and never depend on a redirect SaaS staying online. Best for business cards, permanent signage, and packaging.',
        ],
      },
      {
        title: 'When Dynamic Makes Sense',
        paragraphs: [
          'Marketing teams that change landing pages weekly without reprinting may accept redirect-based dynamic codes. Budget for subscription costs and vendor lock-in.',
        ],
      },
    ],
  },
  'restaurant-qr-menu-ideas': {
    sections: [
      {
        title: 'Placement and Design',
        paragraphs: [
          'Table tents at eye level, laminated cards, and window stickers outperform tiny codes on dark wood. Add "Scan for menu" in the guest language. Ensure the mobile page loads fast on 4G.',
        ],
      },
    ],
  },
  'us-to-eu-shoe-size-conversion': {
    sections: [
      {
        title: 'Men\'s Conversion Table',
        paragraphs: [
          'US 8 ≈ EU 41, US 9 ≈ EU 42, US 10 ≈ EU 43–44, US 11 ≈ EU 44–45. Always cross-check foot length in CM. Athletic brands may differ by half size.',
        ],
      },
      {
        title: 'Women\'s Conversion Table',
        paragraphs: [
          'US 7 ≈ EU 37–38, US 8 ≈ EU 38–39, US 9 ≈ EU 40. UK women\'s sizes run different from US — use our size converter tool for interactive lookup.',
        ],
      },
    ],
  },
  'how-to-measure-feet-for-shoe-size': {
    sections: [
      {
        title: 'Step-by-Step Measurement',
        paragraphs: [
          'Place paper on hard floor, stand with heel against wall, mark longest toe, measure CM with ruler. Do both feet evening. Add 0.5–1 cm for running shoes if toes touch front when standing.',
        ],
      },
    ],
  },
};
